import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=38ac66eb"
import script from "./Repairs.vue?vue&type=script&lang=ts"
export * from "./Repairs.vue?vue&type=script&lang=ts"
import style0 from "./Repairs.vue?vue&type=style&index=0&id=38ac66eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports